module.exports = __webpack_public_path__ + "components/rewards/bird-eyewear/static/logo-9d3c14eb4f6d14bddd4dbd9ad3e97d2a.webp";